import { StarsInfo } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';

import {
  TXTCLI_Thank_youX,
  TXTWCL_The_response_will_be_sent_to_t_ELL
} from './SuccessMessage.messages.json';

const SuccessMessage: React.FC = () => {
  const brand = useSelector(select.cms.getBrandName);

  return (
    <StarsInfo type="confirmation">
      <Translation
        {...TXTWCL_The_response_will_be_sent_to_t_ELL}
        values={{ accountBrand: brand }}
      />
      <Translation {...TXTCLI_Thank_youX} />
    </StarsInfo>
  );
};

export default SuccessMessage;
